<template>
  <div class="navbar-shell" :class="{ 'navbar-shell--auto-hide': autoHide }">
    <div
        v-if="autoHide"
        class="navbar-hover-zone"
        @mouseenter="mostrarNavbar"
        @focus="mostrarNavbar"
    ></div>

    <v-app-bar
        :app="!autoHide"
        :fixed="autoHide"
        color="primary"
        dark
        class="app-navbar"
        :class="{
          'app-navbar--auto-hide': autoHide,
          'app-navbar--visible': navbarVisivel
        }"
        :height="$vuetify.breakpoint.xs ? 56 : 72"
        @mouseenter="mostrarNavbar"
        @mouseleave="esconderNavbar"
        @focusin="mostrarNavbar"
    >
      <v-app-bar-nav-icon
          class="d-md-none"
          aria-label="Abrir menu"
          @click="drawer = true"
      ></v-app-bar-nav-icon>

      <div class="d-flex align-center">
        <v-img
            alt="Logo"
            class="shrink mr-2 cursor-pointer"
            contain
            src="@/assets/logo.png"
            transition="scale-transition"
            :width="$vuetify.breakpoint.xs ? 44 : 68"
            :height="$vuetify.breakpoint.xs ? 44 : 68"
            @click="irParaBuscaCliente"
        />
      </div>

      <v-spacer></v-spacer>

      <div class="desktop-nav d-none d-md-flex align-center">
        <v-menu offset-y open-on-hover>
          <template v-slot:activator="{ on, attrs }">
            <v-btn text v-bind="attrs" v-on="on">
              <v-icon left>mdi-gift</v-icon>
              Gerenciar Casamento
              <v-icon right>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item to="/casamento-admin/convidados">
              <v-icon left class="mr-2" color="primary">mdi-account-multiple</v-icon>
              <v-list-item-title>Gerenciar Convidados</v-list-item-title>
            </v-list-item>
            <v-list-item to="/casamento-admin/presentes">
              <v-icon left class="mr-2" color="primary">mdi-gift</v-icon>
              <v-list-item-title>Gerenciar Presentes</v-list-item-title>
            </v-list-item>
            <v-list-item to="/casamento-admin/mural">
              <v-icon left class="mr-2" color="primary">mdi-image-multiple</v-icon>
              <v-list-item-title>Mural do Casamento</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-btn text class="mx-2" to="/estudar">
          <v-icon left>mdi-book-open-variant</v-icon>
          Estudar
        </v-btn>

        <v-btn text class="mx-2" to="/financas">
          <v-icon left>mdi-wallet-outline</v-icon>
          Finanças
        </v-btn>

        <v-btn v-if="temCasa" text class="mx-2" to="/casa">
          <v-icon left>mdi-home-automation</v-icon>
          Casa
        </v-btn>

        <v-btn text class="mx-2" to="/busca-cliente">
          <v-icon left>mdi-magnify</v-icon>
          Buscar
        </v-btn>

        <v-menu offset-y open-on-hover>
          <template v-slot:activator="{ on, attrs }">
            <v-btn text v-bind="attrs" v-on="on">
              <v-icon left>mdi-view-list</v-icon>
              Listas
              <v-icon right>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item to="/clientes">
              <v-icon left class="mr-2" color="primary">mdi-account-group</v-icon>
              <v-list-item-title>Clientes</v-list-item-title>
            </v-list-item>
            <v-list-item to="/compromissos">
              <v-icon left class="mr-2" color="primary">mdi-calendar-check</v-icon>
              <v-list-item-title>Compromissos</v-list-item-title>
            </v-list-item>
            <v-list-item to="/pagamentos">
              <v-icon left class="mr-2" color="primary">mdi-cash</v-icon>
              <v-list-item-title>Pagamentos</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>

      <v-menu offset-y :left="$vuetify.breakpoint.smAndDown">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" aria-label="Notificações">
            <v-icon>mdi-bell</v-icon>
            <v-badge
                v-if="notificacoes.length > 0"
                color="red"
                overlap
                content="!"
                class="notification-badge"
            ></v-badge>
          </v-btn>
        </template>

        <v-list class="notifications-list">
          <v-list-item v-if="notificacoes.length === 0">
            <v-list-item-title>Nenhuma notificação</v-list-item-title>
          </v-list-item>

          <v-divider v-if="notificacoes.length > 0"></v-divider>

          <v-list-item
              v-for="(notificacao, index) in notificacoes"
              :key="index"
          >
            <v-list-item-content>
              <v-list-item-title>{{ notificacao.titulo }}</v-list-item-title>
              <v-list-item-subtitle>{{ notificacao.descricao }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-navigation-drawer
        v-model="drawer"
        app
        temporary
        width="300"
        class="d-md-none mobile-drawer"
    >
      <v-list-item class="primary white--text">
        <v-list-item-avatar>
          <v-img src="@/assets/logo.png" contain></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="font-weight-medium">Lau Schedule</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn icon dark @click="drawer = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>

      <v-list nav dense class="py-2">
        <v-list-item to="/estudar" @click="drawer = false">
          <v-list-item-icon><v-icon color="primary">mdi-book-open-variant</v-icon></v-list-item-icon>
          <v-list-item-title>Estudar</v-list-item-title>
        </v-list-item>

        <v-list-item to="/estudar/lauschecks" @click="drawer = false">
          <v-list-item-icon><v-icon color="primary">mdi-checkbox-marked-circle-outline</v-icon></v-list-item-icon>
          <v-list-item-title>LauChecks</v-list-item-title>
        </v-list-item>

        <v-list-item to="/financas" @click="drawer = false">
          <v-list-item-icon><v-icon color="primary">mdi-wallet-outline</v-icon></v-list-item-icon>
          <v-list-item-title>Finanças</v-list-item-title>
        </v-list-item>

        <v-list-item v-if="temCasa" to="/casa" @click="drawer = false">
          <v-list-item-icon><v-icon color="primary">mdi-home-automation</v-icon></v-list-item-icon>
          <v-list-item-title>Casa</v-list-item-title>
        </v-list-item>

        <v-list-item to="/busca-cliente" @click="drawer = false">
          <v-list-item-icon><v-icon color="primary">mdi-magnify</v-icon></v-list-item-icon>
          <v-list-item-title>Buscar</v-list-item-title>
        </v-list-item>

        <v-divider class="my-2"></v-divider>

        <v-subheader>Listas</v-subheader>
        <v-list-item to="/clientes" @click="drawer = false">
          <v-list-item-icon><v-icon color="primary">mdi-account-group</v-icon></v-list-item-icon>
          <v-list-item-title>Clientes</v-list-item-title>
        </v-list-item>
        <v-list-item to="/compromissos" @click="drawer = false">
          <v-list-item-icon><v-icon color="primary">mdi-calendar-check</v-icon></v-list-item-icon>
          <v-list-item-title>Compromissos</v-list-item-title>
        </v-list-item>
        <v-list-item to="/pagamentos" @click="drawer = false">
          <v-list-item-icon><v-icon color="primary">mdi-cash</v-icon></v-list-item-icon>
          <v-list-item-title>Pagamentos</v-list-item-title>
        </v-list-item>

        <v-divider class="my-2"></v-divider>

        <v-subheader>Casamento</v-subheader>
        <v-list-item to="/casamento-admin/convidados" @click="drawer = false">
          <v-list-item-icon><v-icon color="primary">mdi-account-multiple</v-icon></v-list-item-icon>
          <v-list-item-title>Gerenciar Convidados</v-list-item-title>
        </v-list-item>
        <v-list-item to="/casamento-admin/presentes" @click="drawer = false">
          <v-list-item-icon><v-icon color="primary">mdi-gift</v-icon></v-list-item-icon>
          <v-list-item-title>Gerenciar Presentes</v-list-item-title>
        </v-list-item>
        <v-list-item to="/casamento-admin/mural" @click="drawer = false">
          <v-list-item-icon><v-icon color="primary">mdi-image-multiple</v-icon></v-list-item-icon>
          <v-list-item-title>Mural do Casamento</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import pagamentoService from "@/services/pagamentoService";
import { compromissoService } from "@/services/compromissoService";
import authService from "@/services/authService";
import casaService from "@/services/casaService";

export default {
  name: "AppNavbar",
  props: {
    autoHide: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    drawer: false,
    navbarVisivelManual: false,
    notificacoes: [],
    temCasa: false,
  }),
  computed: {
    navbarVisivel() {
      return !this.autoHide || this.navbarVisivelManual || this.drawer;
    },
  },
  created() {
    this.carregarNotificacoes();
  },
  mounted() {
    if (authService.isAuthenticated()) casaService.temAcesso().then((ok) => { this.temCasa = ok; });
  },
  watch: {
    autoHide() {
      this.navbarVisivelManual = false;
    },
    '$route.path'() {
      this.navbarVisivelManual = false;
      this.drawer = false;
    },
  },
  methods: {
    mostrarNavbar() {
      if (this.autoHide) {
        this.navbarVisivelManual = true;
      }
    },
    esconderNavbar() {
      if (this.autoHide && !this.drawer) {
        this.navbarVisivelManual = false;
      }
    },
    irParaBuscaCliente() {
      this.$router.push({ name: "BuscaCliente" });
      this.drawer = false;
    },
    async carregarNotificacoes() {
      try {
        const resultadoPagamentos = await pagamentoService.getPagamentosVencidosEProximosAVencer();
        const compromissos = await compromissoService.getCompromissosProximosAVencer();

        const pagamentosVencidos = resultadoPagamentos.vencidos.filter(
            pagamento => !['PAGO', 'CANCELADO'].includes(pagamento.status?.toUpperCase())
        );
        const pagamentosProximosAVencer = resultadoPagamentos.proximosAVencer.filter(
            pagamento => !['PAGO', 'CANCELADO'].includes(pagamento.status?.toUpperCase())
        );

        pagamentosVencidos.forEach((pagamento) => {
          this.notificacoes.push({
            titulo: "Pagamento Vencido",
            descricao: `Pagamento de ${pagamento.clienteNome} venceu em ${pagamento.dataPagamento}.`,
          });
        });

        pagamentosProximosAVencer.forEach((pagamento) => {
          this.notificacoes.push({
            titulo: "Pagamento Próximo a Vencer",
            descricao: `Pagamento de ${pagamento.clienteNome} vence em ${pagamento.dataPagamento}.`,
          });
        });

        compromissos.vencidos.forEach((compromisso) => {
          this.notificacoes.push({
            titulo: "Compromisso Vencido",
            descricao: `Compromisso "${compromisso.titulo}" venceu em ${compromisso.data} às ${compromisso.hora}.`,
          });
        });

        compromissos.proximosAVencer.forEach((compromisso) => {
          this.notificacoes.push({
            titulo: "Compromisso Próximo a Vencer",
            descricao: `Compromisso "${compromisso.titulo}" será em ${compromisso.data} às ${compromisso.hora}.`,
          });
        });
      } catch (error) {
        console.error("Erro ao carregar notificações:", error);
        this.$toast.error("Erro ao carregar notificações.");
      }
    },
  },
};
</script>

<style scoped>
.app-navbar {
  overflow: hidden;
}

.navbar-hover-zone {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 18px;
  z-index: 7;
}

.app-navbar--auto-hide {
  transform: translateY(calc(-100% - 2px));
  opacity: 0;
  pointer-events: none;
  transition: transform 0.22s ease, opacity 0.18s ease, box-shadow 0.18s ease;
  box-shadow: 0 14px 30px rgba(35, 27, 21, 0.18) !important;
}

.app-navbar--auto-hide.app-navbar--visible {
  transform: translateY(0);
  opacity: 1;
  pointer-events: auto;
}

.desktop-nav {
  min-width: 0;
}

.notification-badge {
  position: absolute;
  top: 0;
  right: 0;
}

.notifications-list {
  max-width: min(360px, calc(100vw - 24px));
  max-height: 420px;
  overflow-y: auto;
}

.mobile-drawer ::v-deep .v-list-item__title,
.notifications-list ::v-deep .v-list-item__title,
.notifications-list ::v-deep .v-list-item__subtitle {
  overflow: visible;
  text-overflow: clip;
  white-space: normal;
  word-break: break-word;
}

@media (max-width: 959px) {
  .app-navbar ::v-deep .v-toolbar__content {
    padding: 0 8px;
  }
}
</style>
